function IntegrityPolicy() {
  return (
<>
  <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
  <title>file_1701763051580</title>
  <style
    type="text/css"
    dangerouslySetInnerHTML={{
      __html:
        ' * {margin:0; padding:0; text-indent:0; }\n h1 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 11pt; }\n .s1 { color: black; font-family:"Times New Roman", serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 11pt; }\n .p, p { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; margin:0pt; }\n .s3 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }\n .s4 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n .s5 { color: black; font-family:"Times New Roman", serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 10pt; }\n h2 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }\n .s6 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n .a, a { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n .s7 { color: #1C1C1C; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n li {display: block; }\n #l1 {padding-left: 0pt;counter-reset: c1 1; }\n #l1> li>*:first-child:before {counter-increment: c1; content: counter(c1, decimal)". "; color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 11pt; }\n #l1> li:first-child>*:first-child:before {counter-increment: c1 0;  }\n #l2 {padding-left: 0pt; }\n #l2> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l3 {padding-left: 0pt; }\n #l3> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l4 {padding-left: 0pt; }\n #l4> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l5 {padding-left: 0pt; }\n #l5> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l6 {padding-left: 0pt; }\n #l6> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l7 {padding-left: 0pt; }\n #l7> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l8 {padding-left: 0pt; }\n #l8> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l9 {padding-left: 0pt; }\n #l9> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l10 {padding-left: 0pt; }\n #l10> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l11 {padding-left: 0pt; }\n #l11> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l12 {padding-left: 0pt; }\n #l12> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l13 {padding-left: 0pt; }\n #l13> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l14 {padding-left: 0pt; }\n #l14> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l15 {padding-left: 0pt; }\n #l15> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l16 {padding-left: 0pt; }\n #l16> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l17 {padding-left: 0pt; }\n #l17> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l18 {padding-left: 0pt; }\n #l18> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l19 {padding-left: 0pt; }\n #l19> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l20 {padding-left: 0pt; }\n #l20> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l21 {padding-left: 0pt; }\n #l21> li>*:first-child:before {content: " "; color: black; font-family:Symbol, serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 11pt; }\n table, tbody {vertical-align: top; overflow: visible; }\n'
    }}
  />
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
    <h1 style={{
      paddingTop: "4pt",
      paddingLeft: "75pt",
      textIndent: "0pt",
      textAlign: "center"
    }} name="bookmark0">SVENSKA BILSPORTSFÖRBUNDETS INTEGRITETSPOLICY</h1>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    className="s1"
    style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
  >
    Senast uppdaterad: <span className="p">Februari 2020</span>
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <ol id="l1">
    <li data-list-text={1}>
      <h2
        style={{ paddingLeft: "41pt", textIndent: "-36pt", textAlign: "left" }}
      >
          VI ANSVARAR FÖR HANTERINGEN AV DINA PERSONUPPGIFTER
      </h2>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        I denna integritetspolicy beskriver vi vilka personuppgifter som vi
        hanterar om dig och varför, samt vilka rättigheter som du har. Svenska
        Bilsportförbundet (Förbundet) ansvarar för hanteringen av dina
        personuppgifter.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        <a href="https://www.sbf.se/" className="a">
          Integritetspolicyn omfattar dig som är medlem i en klubb, använder vår
          webbplats (
        </a>
        <span
          style={{
            color: "#00F",
            fontFamily: '"Times New Roman", serif',
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "underline",
            fontSize: "11pt"
          }}
        >
          https://www.sbf.se
        </span>
        ), deltar i möten, utbildningar och andra aktiviteter som vi arrangerar,
        företräder en verksamhet som samarbetar med eller levererar varor och
        tjänster till oss, samt dig som kommunicerar med oss på olika sätt.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={2}>
      <h2
        style={{ paddingLeft: "41pt", textIndent: "-36pt", textAlign: "left" }}
      >
          FRÅN VILKA KÄLLOR VI SAMLAR IN DINA PERSONUPPGIFTER
      </h2>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi samlar in personuppgifter om dig från olika källor:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify", fontWeight: "bold" }}
      >
        Dig själv
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi samlar in personuppgifter från dig bland annat när du kommunicerar
        med oss, deltar i utbildningar, möten och andra aktiviteter, i samband
        med ansökan om tävlingslicens och tävlingar och när du besöker vår
        webbplats.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}>
        Klubbar
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi samlar in personuppgifter om dig från din klubb, t.ex. när klubben
        registerar dina uppgifter i klubbens medlemsregister i
        Riksidrottsförbundets system IdrottOnline.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}>
        Arrangörer
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left" }}>
        Om du deltar i en tävling eller annan aktivitet som arrangörer anordnar
        kan vi samla in personuppgifter om dig från arrangören.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}>
       Betaltjänstleverantörer
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left" }}>
        Om du använder några betaltjänstleverantörer när du genomför en
        betalning till oss samlar vi in personuppgifter om dig avseende det
        genomförda köpet.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}>
        Internationella Bilsportsförbundet (FIA)
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left" }}>
          Vi kan samla in personuppgifter om dig från Internationella
          Bilsportsförbundet, t.ex. om du är en internationell funktionär.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}>
        Externa personer
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi kan även samla in personuppgifter om dig från andra externa personer
        som lämnar dina personuppgifter till oss, t.ex. i samband med
        kommunikation.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={3}>
      <h2
        style={{
          paddingTop: "4pt",
          paddingLeft: "41pt",
          textIndent: "-36pt",
          textAlign: "left"
        }}
      >
          VI ANVÄNDER DINA PERSONUPPGIFTER FÖR OLIKA SYFTEN
      </h2>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left" }}>
        Vi använder dina personuppgifter för att:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}>
        Hantera licenser
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi använder dina personuppgifter för att hantera licenser, t.ex. för att
        utfärda och registrera licenser och administrera betalningen av
        licenser, ge dig tillgång till Licens och Tävlingssy-stemet (LotS) via
        webbplatsen eller vår mobilapp, samt för att kommunicera med dig för
        samma syfte. Du behöver lämna de uppgifter som vi efterfrågar när du
        ansöker om en licens. Om du inte lämnar den information som vi
        efterfrågar kan vi inte hantera din ansökan.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "98pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Avtal.{" "}
                <span className="s4">
                  Behandlingen är nödvändig för att uppfylla avtalet med dig.
                </span>
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Uttryckligt samtycke.{" "}
                <span className="s4">
                  Särskilda kategorier av personuppgifter om hälsa behandlas med
                  stöd av ditt uttryckliga samtycke som du lämnar i ditt
                  läkarintyg.
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "116pt" }}>
            <td
              style={{
                width: "428pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              colSpan={2}
            >
              <p
                className="s3"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Bevarandetid:{" "}
                <span className="s4">
                  Dina personuppgifter bevaras så länge din licens är aktiv och
                  för en tid om fem (5) är därefter för samma syfte, samt under
                  en tid om tio (10) år räknat från tidpunkten din licens
                  registrerades för att tillgodose Förbundets berättigade
                  intresse av att hantera och bemöta eventuella rättsliga krav.
                  Läkarintyg bevaras under en period om två (2) år räknat från
                  tidpunkten vi tog emot intyget för samma syfte.
                </span>
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Personuppgifter i bokföringsmaterial bevaras för en tid om sju
                (7) år räknat från utgången av det kalenderår då relevant
                räkenskapsår avslutades för att uppfylla rättsliga skyldigheter
                (bokförings- och redovisningskrav i bokföringslagen
                (1999:1078)).
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l2">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Fordonsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Hälsouppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Klubbuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kommunikation
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kontaktuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Tekniska uppgifter
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}>
        Hantera tävlingar
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi använder dina personuppgifter för att hantera tävlingar, t.ex. för
        att registrera och publicera ditt deltagande i tävlingar och dina
        tävlingsresultat, hantera avstängningar, samt för att kommunicera med
        dig och andra för samma syfte.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "85pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse
                <span className="s4">
                  . Behandlingen är nödvändig för att tillgodose vårt
                  berättigade intresse av att hantera tävlingar.
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "58pt" }}>
            <td
              style={{
                width: "428pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              colSpan={2}
            >
              <p
                className="s3"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Bevarandetid:{" "}
                <span className="s4">
                  Dina personuppgifter bevaras under tävlingen för detta syfte
                  och därefter tillsvidare för att tillgodose Förbundets
                  berättigade intresse av att bevara uppgifter för arkivändamål,
                  vetenskapliga och historiska forskningsändamål, samt för
                  statistiska ändamål. Publicerade uppgifter i våra digitala
                  kanaler bevaras, som utgångspunkt, tillsvidare.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l3">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Fordonsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kommunikation
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kontaktuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Tävlandestatus
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Tävlingsuppgifter
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingTop: "4pt",
          paddingLeft: "41pt",
          textIndent: "0pt",
          textAlign: "justify",
          fontWeight: "bold"
        }}
      >
        Hantera medlemskapet
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi använder dina personuppgifter för att hantera klubbens medlemskap i
        Förbundet, t.ex. administrera medlemsregistret och medlemsavgifter,
        hantera ansökningar om bidrag, samt kommunicera i samma syfte.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "61pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse.{" "}
                <span className="s4">
                  Behandlingen är nödvändig för att tillgodose Förbundets
                  berättigade intresse av att hantera klubbens medlemskap.
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "58pt" }}>
            <td
              style={{
                width: "428pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              colSpan={2}
            >
              <p
                className="s3"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Bevarandetid:{" "}
                <span className="s4">
                  Dina personuppgifter bevaras så länge som klubben är medlem i
                  Förbundet. Personuppgifter i bokföringsmaterial bevaras för en
                  tid om sju (7) år räknat från utgången av det kalenderår då
                  relevant räkenskapsår avslutades för att uppfylla rättsliga
                  skyldigheter (bokförings- och redovisningskrav i
                  bokföringslagen (1999:1078)).
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l4">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kommunikation
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kontaktuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Organisatorisk information
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify", fontWeight: "bold" }}
      >
        Besvara frågor
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi använder dina personuppgifter för att besvara frågor i olika kanaler,
        t.ex. via mejl.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "73pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse
                <span className="s4">
                  . Behandlingen är nödvändig för att tillgodose vårt
                  berättigade intresse av att besvara dina frågor.
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "58pt" }}>
            <td
              style={{
                width: "428pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              colSpan={2}
            >
              <p
                className="s3"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Bevarandetid:{" "}
                <span className="s4">
                  Personuppgifter bevaras för detta syfte under en period om två
                  (2) år räknat från tidpunkten för den senaste kommunikationen
                  i samma konversation. Kommunikation i digitala kanaler
                  bevaras, som utgångspunkt, tillsvidare för detta syfte.
                  Rapporter på övergripande nivå som inte innehåller några
                  personuppgifter och statistik sparas tillsvidare.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l5">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Klubbuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kommunikation
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kontaktuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Organisatorisk information
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify", fontWeight: "bold" }}
      >
        Hantera förhållandet med externa parter
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi använder dina personuppgifter för att hantera förhållandet med
        externa parter såsom leverantörer och samarbetspartners, t.ex. för att
        registrera dina kontaktuppgifter, administrera fakturor, för att hantera
        och arkivera avtal, samt för att kommunicera med dig för samma syfte.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "92pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse
                <span className="s4">
                  . Behandlingen är nödvändig för att tillgodose vårt
                  berättigade intresse av att hantera förhållandet med den
                  externa parten.
                </span>
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Personnummer.{" "}
                <span className="s4">
                  Behandlingen av personnummer är nödvändig med hänsyn till
                  ändamålet med behandlingen.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l6">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              paddingRight: "4pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter, inklusive personnummer (om enskild firma)
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kommunikation
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kontaktuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Organisatorisk information
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <h2
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Bevarandetid:{" "}
        <span className="s6">
          Dina personuppgifter bevaras under den tid som du är kontaktperson för
          den externa parten och för en tid om tio (10) år därefter för att
          tillgodose vårt berättigade intresse av att hantera och bemöta
          rättsliga krav, samt för den tid därefter som är nödvändig för att
          hantera kravet. Personuppgifter i bok-föringsmaterial sparas enligt
          bokföringslagen under en period om sju (7) år räknat efter utgången av
          det kalenderår då aktuellt räkenskapsår avslutades.
        </span>
      </h2>
      <p
        style={{ paddingLeft: "36pt", textIndent: "0pt", textAlign: "left" }}
      />
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingTop: "4pt",
          paddingLeft: "41pt",
          textIndent: "0pt",
          textAlign: "justify",
          fontWeight: "bold"
        }}
      >
        Hantera och dokumentera verksamheten
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi använder dina personuppgifter för att hantera och dokumentera
        verksamheten, t.ex. för att upprätta protokoll från möten,
        beslutsunderlag, presentationer och annan verksamhetsdoku-mentation.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "85pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse
                <span className="s4">
                  . Behandlingen är nödvändig för att tillgodose vårt
                  berättigade intresse av att hantera och dokumentera
                  verksamheten.
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "35pt" }}>
            <td
              style={{
                width: "428pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              colSpan={2}
            >
              <p
                className="s3"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Bevarandetid:{" "}
                <span className="s4">
                  Dina personuppgifter bevaras, som utgångspunkt, för detta
                  syfte tillsvidare och så länge Förbundets verksamhet.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l7">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Bild- och ljudmaterial
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Klubbuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kommunikation
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kontaktuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Organisatorisk information
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify", fontWeight: "bold" }}
      >
        Kommunicera om Förbundet
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi använder dina personuppgifter för att kommunicera om Förbundet och
        dess verksamhet, t.ex. tillhandahålla vårt nyhetsbrev och för att
        publicera nyheter och information om verksamheten i olika digitala
        kanaler exempelvis på webbplatsen.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "73pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse.{" "}
                <span className="s4">
                  Behandlingen är nödvändig för att tillgodose vårt berättigade
                  intresse av att kommunicera om Förbundet och dess verksamhet.
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "47pt" }}>
            <td
              style={{
                width: "428pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              colSpan={2}
            >
              <p
                className="s3"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Bevarandetid:{" "}
                <span className="s4">
                  Dina personuppgifter bevaras så länge som du är registrerad
                  som aktiv inom bilsporten eller till dess att du avregistrerar
                  dig från utskick. Publicerade personuppgifter i olika digitala
                  kanaler bevaras, som utgångspunkt, tillsvidare.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l8">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Bild- och ljudmaterial
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Klubbuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kontaktuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Organisatorisk information
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify", fontWeight: "bold" }}
      >
        Kommunicera erbjudanden
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi använder dina personuppgifter för att kommunicera relevanta
        erbjudanden till dig om våra och våra utvalda samarbetspartners varor
        och tjänster i olika kanaler. Genom att bli medlem i en klubb och
        registrera dig som aktiv inom bilsporten lämnar du ditt samtycke enligt
        mark-nadsföringslagen till vår elektroniska marknadsföring av våra egna
        och våra utvalda samarbetspartners varor och tjänster. Du har rätt att,
        när som helst, avregistrera dig från utskick. Vi delar, när det är nödvändigt, dina personuppgifter med våra
        samarbetsparterns för detta syfte, se avsnitt 4 nedan.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "69pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse.{" "}
                <span className="s4">
                  Behandlingen är nödvändig för att tillgodose vårt och våra
                  utvalda samarbetspartners berättigade intresse av att
                  kommunicera relevanta erbjudanden till dig.
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "35pt" }}>
            <td
              style={{
                width: "428pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              colSpan={2}
            >
              <p
                className="s3"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Bevarandetid:{" "}
                <span className="s4">
                  Dina personuppgifter bevaras för detta syfte så länge som du
                  är registrerad som aktiv inom bilsporten och för en period om
                  12 månader därefter för samma syfte.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l9">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Kontaktuppgifter
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify", fontWeight: "bold" }}
      >
        Följa upp och utvärdera verksamheten
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi använder dina personuppgifter för att följa upp och utvärdera
        verksamheten, t.ex. för att ta fram rapporter och statistik.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "58pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse.{" "}
                <span className="s4">
                  Behandlingen är nödvändig för att tillgodose vårt berättigade
                  intresse av att följa upp och utvärdera verksamheten.
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "35pt" }}>
            <td
              style={{
                width: "428pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              colSpan={2}
            >
              <p
                className="s3"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "7pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Bevarandetid:{" "}
                <span className="s4">
                  Statistik och rapporter som inte innehåller några
                  personuppgifter bevaras tillsvidare eller till dess att de
                  raderas.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l10">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Organisatorisk information
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Klubbuppgifter
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify", fontWeight: "bold" }}
      >
        Genomföra utbildningar, möten och andra aktiviteter 
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi använder dina personuppgifter för att genomföra utbildningar, möten
        och andra aktiviteter, t.ex. för att registrera och dokumentera ditt
        deltagande, upprätta utbildningsintyg och för att kommunicera med dig
        för samma syfte.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "127pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse.{" "}
                <span className="s4">
                  Behandlingen är nödvändig för att tillgodose vårt berättigade
                  intresse av att genomföra utbildningar, möten och andra
                  aktiviteter.
                </span>
              </p>
              <p style={{ textIndent: "0pt", textAlign: "left" }}>
                <br />
              </p>
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Uttryckligt samtycke.{" "}
                <span className="s4">
                  Eventuella särskilda kategorier av personuppgifter, till
                  exempel hälsouppgifter, behandlas vi endast om du frivilligt
                  lämnar sådana uppgifter till oss och då med stöd av ditt
                  uttryckliga samtycke.
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "58pt" }}>
            <td
              style={{
                width: "428pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              colSpan={2}
            >
              <p
                className="s3"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Bevarandetid:{" "}
                <span className="s4">
                  Personuppgifter i deltagarlistor bevaras under en period om 13
                  månader räknat från tidpunkten för mötet för att tillgodose
                  vårt berättigade intresse av att följa upp deltagandet och
                  utvärdera genomförda utbildningar, möten och andra
                  aktiviteter. Uppgifter i utbildningsintyg bevaras under en
                </span>
              </p>
              <p
                className="s4"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  lineHeight: "12pt",
                  textAlign: "justify"
                }}
              >
                period om två (2) år räknat från tidpunkten för utbildningen.
                Personuppgifter i bokföringsmaterial bevaras för en tid om sju
                (7) år räknat från utgången av det kalenderår då relevant
                räkenskapsår avslutades
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l11">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Klubbuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kommunikation
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kontaktuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Matpreferenser
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Organisatorisk information
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Utbildningsuppgifter
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s6"
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
      >
        för att uppfylla rättsliga skyldigheter (bokförings- och
        redovisningskrav i bokföringslagen (1999:1078)).
      </p>
      <p
        style={{ paddingLeft: "36pt", textIndent: "0pt", textAlign: "left" }}
      />
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingTop: "4pt",
          paddingLeft: "41pt",
          textIndent: "0pt",
          textAlign: "left",
          fontWeight: "bold"
        }}
      >
        Genomföra enkätundersökningar
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left" }}>
        Vi använder dina personuppgifter för att genomföra enkätundersökningar,
        t.ex. för att för att skicka ut undersökningen och för att sammanställa
        de svar som lämnas i en rapport.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "58pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse.{" "}
                <span className="s4">
                  Behandlingen är nödvändig för att tillgodose vårt berättigade
                  intresse av att genomföra enkätundersökningar.
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "46pt" }}>
            <td
              style={{
                width: "428pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              colSpan={2}
            >
              <p
                className="s3"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Bevarandetid:{" "}
                <span className="s4">
                  Dina personuppgifter bevaras under den tid som utvärderingen
                  genomförs och för en period om tre (3) månader därefter för
                  att sammanställa rapporter. Statistik och rapporter som inte
                  innehåller några personuppgifter bevaras tillsvidare eller
                  till dess att de raderas.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l12">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kontaktuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Kommunikation
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}>
        Analysera användningen av webbplatsen
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi använder dina personuppgifter för att analysera användningen av
        webbplatsen, t.ex. för att samla in och analysera besöks- och
        klickstatistik.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "58pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse.{" "}
                <span className="s4">
                  Behandlingen är nödvändig för att tillgodose vårt berättigade
                  intresse av att analysera användningen av webbplatsen.
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "35pt" }}>
            <td
              style={{
                width: "428pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              colSpan={2}
            >
              <p
                className="s3"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Bevarandetid:{" "}
                <span className="s4">
                  Dina personuppgifter bevaras för en tid om en (1) månad för
                  detta syfte. Statistik och rapporter som inte innehåller några
                  personuppgifter bevaras tillsvidare eller till dess att de
                  raderas.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l13">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Användargenererade uppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Tekniska uppgifter
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}>
          Säkerställa teknisk funktionalitet och säkerhet i våra system och
          tjänster
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi använder dina personuppgifter för att säkerställa teknisk
        funktionalitet och säkerhet i våra system och tjänster, t.ex. för 
        säkerhetsloggning, fel- och incidenthantering och säkerhetskopiering.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "70pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Samtliga uppgifter som anges ovan.
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse.{" "}
                <span className="s4">
                  Behandlingen är nödvändig för att tillgodose vårt berättigade
                  intresse av att säkerställa teknisk funktionalitet och
                  säkerhet i våra system och tjänster.
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "35pt" }}>
            <td
              style={{
                width: "428pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              colSpan={2}
            >
              <p
                className="s3"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  lineHeight: "12pt",
                  textAlign: "justify"
                }}
              >
                Bevarandetid:{" "}
                <span className="s4">
                  Dina personuppgifter bevaras under samma period som anges i
                  förhållande till respektive angivet ändamål med behandlingen
                  av dina personuppgifter ovan. Personuppgifter i loggar bevaras
                  för felsökning och incidenthantering under en tid om 12
                  månader räknat från tidpunkten för logghändelsen.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p
        className="s6"
        style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
      >
      </p>
      <p
        style={{ paddingLeft: "36pt", textIndent: "0pt", textAlign: "left" }}
      />
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingTop: "4pt",
          paddingLeft: "41pt",
          textIndent: "0pt",
          textAlign: "left",
          fontWeight: "bold"
        }}
      >
        Övriga ändamål
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left" }}>
        Vi kan även använda dina personuppgifter för att:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s1"
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}
      >
        Hantera och bemöta rättsliga krav
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
       
          Om det är nödvändigt använder vi dina personuppgifter för att hantera
          och bemöta rättsliga krav, t.ex. i samband med en tvist eller en
          rättsprocess. För detta syfte kan vi dela viss information med andra
          mottagare, se nedan under avsnitt 4.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "46pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Samtliga uppgifter som är nödvändiga för att hantera och bemöta
                det rättsliga kravet.
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse.{" "}
                <span className="s4">
                  Behandlingen är nödvändig för att tillgodose vårt berättigade
                  intresse av att hantera och bemöta rättsliga krav.
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "35pt" }}>
            <td
              style={{
                width: "428pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              colSpan={2}
            >
              <p
                className="s3"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Bevarandetid:{" "}
                <span className="s4">
                  Dina personuppgifter bevaras för detta syfte för den tid som
                  är nödvändig för att hantera eller bemöta det rättsliga
                  kravet.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s1"
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify", fontWeight: "bold" }}
      >
        Uppfylla rättsliga skyldigheter
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
          Slutligen använder vi dina personuppgifter för att uppfylla rättsliga
          skyldigheter som vi har, t.ex. skyldigheter enligt
          dataskyddslagstiftning. För detta syfte kan vi dela viss information
          med andra mottagare, se nedan under avsnitt 4.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "47pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "24pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Samtliga uppgifter som samlats in och som är nödvändiga för att
                uppfylla respektive rättslig skyldighet.
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Rättslig förpliktelse.{" "}
                <span className="s4">
                  Behandlingen är nödvändig för att uppfylla rättsliga
                  förpliktelser som gäller för oss.
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "35pt" }}>
            <td
              style={{
                width: "428pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              colSpan={2}
            >
              <p
                className="s3"
                style={{
                  paddingLeft: "5pt",
                  textIndent: "0pt",
                  textAlign: "left"
                }}
              >
                Bevarandetid:{" "}
                <span className="s4">
                  Personuppgifter bevaras under den tid som är nödvändig för att
                  vi ska uppfylla respektive rättslig skyldighet.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={4}>
      <h2
        style={{ paddingLeft: "41pt", textIndent: "-36pt", textAlign: "left" }}
      >
        DELNING AV PERSONUPPGIFTER
      </h2>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Nedanför beskriver vi med vilka kategorier av mottagare som – när det är
        nödvändigt – delar dina personuppgifter med.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}>
        Tjänsteleverantörer
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        För att uppfylla ändamålen med behandlingen av dina personuppgifter
        delar vi personuppgifter med tjänsteleverantörer som vi har anlitat.
        Dessa tjänsteleverantörer tillhandahåller IT-tjänster till oss.
        Tjänsteleverantörerna får endast behandla dina personuppgifter för dessa
        syften enligt våra instruktioner och inte för några egna ändamål. Vi
        ansvarar för behandlingen av personuppgifter som tjänsteleverantörerna
        utför på vårt uppdrag.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}>
        Allmänheten
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingTop: "4pt",
          paddingLeft: "41pt",
          textIndent: "0pt",
          textAlign: "justify"
        }}
      >
        Personuppgifter som publicerats i våra digitala kanaler för att
        kommunicera om Förbundet och dess verksamhet (t.ex. publicera
        mötesprotokoll) och för att hantera tävlingar (t.ex. tävlingsresultat)
        är offentliga och kan ses av vem som helst.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s1"
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}
      >
        Kommunicera om Förbundet
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "46pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse.{" "}
                <span className="s4">
                  Behandlingen är nödvändig för att tillgodose vårt berättigade
                  intresse av att hantera tävlingar.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l14">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kontaktuppgifter
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        className="s1"
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}
      >
        Hantera tävlingar
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "47pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse
                <span className="s4">
                  . Behandlingen är nödvändig för att tillgodose vårt
                  berättigade intresse av att hantera tävlingar.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l15">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Tävlingsuppgifter
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}>
        Utvalda samarbetspartners
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
          För att våra utvalda samarbetspartners ska kunna lämna relevanta
          erbjudanden till dig om sina varor och tjänster delar vi, när det är
          nödvändigt, dina personuppgifter med dessa. En lista över våra utvalda
          samarbetspartners finns på webbplatsen. Du har rätt att, när som
          helst, motsätta dig att dina personuppgifter lämnas ut för detta syfte
          till våra samarbetsparterns. Om du vill motsätta dig dina
          personuppgifter lämnas ut vänligen kontakta kansliet, se
          kontaktuppgifter i avsnitt 8 nedan.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "58pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse.{" "}
                <span className="s4">
                  Behandlingen är nödvändig för att tillgodose vårt och våra
                  utvalda samarbetspartners berättigade intresse av att
                  kommunicera relevanta erbjudanden till dig.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l16">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Kontaktuppgifter
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}>
        Internationella Bilsportförbundet (FIA)
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left" }}>
        Vi delar personuppgifter med Internationella Bilsportförbundet för att
        hantera tävlingar.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "47pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse
                <span className="s4">
                  . Behandlingen är nödvändig för att tillgodose vårt
                  berättigade intresse av att hantera tävlingar.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l17">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Fordonsuppgifter
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingTop: "4pt",
          paddingLeft: "41pt",
          textIndent: "0pt",
          textAlign: "left",
          fontWeight: "bold"
        }}
      >
        Externa personer
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left" }}>
        Vid kommunikation med externa personer delar vi de personuppgifter som
        du själv eller annan lämnar till de externa personerna.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "61pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse.{" "}
                <span className="s4">
                  Behandlingen är nödvändig för att tillgodose vårt berättigade
                  intresse av att kommunicera med externa personer.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l18">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kontaktuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Organisatorisk information
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Kommunikation
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}>
        Arrangörer
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left" }}>
          För att hantera tävlingar delar vi, när det är nödvändigt,
          personuppgifter med arrangörer.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "61pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse.{" "}
                <span className="s4">
                  Behandlingen är nödvändig för att tillgodose vårt och
                  arragörens berättigade intresse av att hantera den aktuella
                  tävlingen.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l19">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Kontaktuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Tävlandestatus
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Tävlingsuppgifter
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}>
        Sociala nätverksplattformar
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left" }}>
          För att kommunicera om Förbundet och dess verksamhet på sociala
          nätverksplattformar (t.ex. Facebook) delar vi viss information med
          dessa plattformar.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <table
        style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
        cellSpacing={0}
      >
        <tbody>
          <tr style={{ height: "24pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Personuppgifter
              </p>
            </td>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
              bgcolor="#F2F2F2"
            >
              <p
                className="s3"
                style={{
                  paddingTop: "6pt",
                  paddingLeft: "72pt",
                  paddingRight: "71pt",
                  textIndent: "0pt",
                  textAlign: "center"
                }}
              >
                Laglig grund
              </p>
            </td>
          </tr>
          <tr style={{ height: "47pt" }}>
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            />
            <td
              style={{
                width: "214pt",
                borderTopStyle: "solid",
                borderTopWidth: "1pt",
                borderTopColor: "#DADADA",
                borderLeftStyle: "solid",
                borderLeftWidth: "1pt",
                borderLeftColor: "#DADADA",
                borderBottomStyle: "solid",
                borderBottomWidth: "1pt",
                borderBottomColor: "#DADADA",
                borderRightStyle: "solid",
                borderRightWidth: "1pt",
                borderRightColor: "#DADADA"
              }}
            >
              <p
                className="s5"
                style={{
                  paddingLeft: "5pt",
                  paddingRight: "4pt",
                  textIndent: "0pt",
                  textAlign: "justify"
                }}
              >
                Berättigat intresse.{" "}
                <span className="s4">
                  Behandlingen är nödvändig för att tillgodose vårt berättigade
                  intresse av att kommunicera om Förbundet och vår verksamhet.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <ul id="l20">
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              lineHeight: "12pt",
              textAlign: "left"
            }}
          >
            Identitetsuppgifter
          </p>
        </li>
        <li data-list-text="">
          <p
            className="s4"
            style={{
              paddingLeft: "23pt",
              textIndent: "-18pt",
              textAlign: "left"
            }}
          >
            Kontaktuppgifter
          </p>
        </li>
      </ul>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left", fontWeight: "bold" }}>
        Övriga mottagare
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left" }}>
        Vi kan även dela dina personuppgifter, om det är nödvändigt, med andra
        mottagare (t.ex. myndigheter, domstolar och externa rådgivare) för att:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <ul id="l21">
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "77pt",
              textIndent: "-18pt",
              lineHeight: "13pt",
              textAlign: "left",
              fontWeight: "bold",
            }}
          >
            hantera och bemöta rättsliga krav
          </p>
        </li>
        <li data-list-text="">
          <p
            style={{
              paddingLeft: "77pt",
              textIndent: "-18pt",
              lineHeight: "13pt",
              textAlign: "left",
              fontWeight: "bold",
            }}
          >
            uppfylla rättsliga skyldigheter.
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <table
            style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
            cellSpacing={0}
          >
            <tbody>
              <tr style={{ height: "24pt" }}>
                <td
                  style={{
                    width: "214pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderTopColor: "#DADADA",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderLeftColor: "#DADADA",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderBottomColor: "#DADADA",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                    borderRightColor: "#DADADA"
                  }}
                  bgcolor="#F2F2F2"
                >
                  <p
                    className="s3"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "72pt",
                      paddingRight: "71pt",
                      textIndent: "0pt",
                      textAlign: "center"
                    }}
                  >
                    Ändamål
                  </p>
                </td>
                <td
                  style={{
                    width: "214pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderTopColor: "#DADADA",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderLeftColor: "#DADADA",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderBottomColor: "#DADADA",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                    borderRightColor: "#DADADA"
                  }}
                  bgcolor="#F2F2F2"
                >
                  <p
                    className="s3"
                    style={{
                      paddingTop: "6pt",
                      paddingLeft: "42pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    Laglig grund för överföringen
                  </p>
                </td>
              </tr>
              <tr style={{ height: "46pt" }}>
                <td
                  style={{
                    width: "214pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderTopColor: "#DADADA",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderLeftColor: "#DADADA",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderBottomColor: "#DADADA",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                    borderRightColor: "#DADADA"
                  }}
                >
                  <p
                    className="s5"
                    style={{
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    Hantera och bemöta rättsliga krav
                  </p>
                </td>
                <td
                  style={{
                    width: "214pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderTopColor: "#DADADA",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderLeftColor: "#DADADA",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderBottomColor: "#DADADA",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                    borderRightColor: "#DADADA"
                  }}
                >
                  <p
                    className="s5"
                    style={{
                      paddingLeft: "5pt",
                      paddingRight: "4pt",
                      textIndent: "0pt",
                      textAlign: "justify"
                    }}
                  >
                    Berättigat intresse.{" "}
                    <span className="s4">
                      Överföringen är nödvändig för att tillgodose vårt
                      berättigade intresse av att hantera och bemöta rättsliga
                      krav.
                    </span>
                  </p>
                </td>
              </tr>
              <tr style={{ height: "23pt" }}>
                <td
                  style={{
                    width: "214pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderTopColor: "#DADADA",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderLeftColor: "#DADADA",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderBottomColor: "#DADADA",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                    borderRightColor: "#DADADA"
                  }}
                >
                  <p
                    className="s5"
                    style={{
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      textAlign: "left"
                    }}
                  >
                    Uppfylla rättliga skyldigheter
                  </p>
                </td>
                <td
                  style={{
                    width: "214pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "1pt",
                    borderTopColor: "#DADADA",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1pt",
                    borderLeftColor: "#DADADA",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1pt",
                    borderBottomColor: "#DADADA",
                    borderRightStyle: "solid",
                    borderRightWidth: "1pt",
                    borderRightColor: "#DADADA"
                  }}
                >
                  <p
                    className="s5"
                    style={{
                      paddingLeft: "5pt",
                      textIndent: "0pt",
                      lineHeight: "12pt",
                      textAlign: "left"
                    }}
                  >
                    Rättslig skyldighet.
                    <span className="s4">
                      Överföringen är nödvändig för att uppfylla rättsliga
                      skyldigheter som gäller för oss.

                    </span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </li>
      </ul>
    </li>
    <li data-list-text={5}>
      <h2
        style={{
          paddingTop: "4pt",
          paddingLeft: "41pt",
          textIndent: "-36pt",
          textAlign: "left"
        }}
      >
        VAR VI BEHANDLAR DINA PERSONUPPGIFTER
      </h2>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi strävar alltid efter att spara personuppgifter inom EU. I vissa fall
        delas dina personuppgifter med mottagare utanför EU/EES-området, t.ex.
        tjänsteleverantörer som vi har anlitat.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        För att säkerställa att personuppgifterna är skyddade ser vi till att
        det finns lämpliga skyddsåtgärder på plats med samtliga
        tjänsteleverantörer som hanterar dina personuppgifter utanför
        EU/EES-området, t.ex. dataöverföringsavtal (som inkluderar
        EU-kommissionens standardise-rade dataskyddsbestämmelser, s.k.
        modellklausuler) eller, vid överföring till USA, att leve-rantören är
        certifierad enligt det s.k. <i>Privacy Shield</i>-ramverket. Du har rätt
        att, på begäran, få information om till vilka länder utanför
        EU/EES-området som dina personuppgifter överförs och vilka
        skyddsåtgärder som Förbundet har vidtagit.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={6}>
      <h2
        style={{ paddingLeft: "41pt", textIndent: "-36pt", textAlign: "left" }}
      >
        DINA RÄTTIGHETER
      </h2>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Du har vissa rättigheter enligt gällande dataskyddslagstiftning i
        förhållande till de personuppgifter som vi har samlat in om dig.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Du har rätt att:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify", fontWeight: "bold" }}
      >
        Begära tillgång (s.k. registerutdrag)
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Du har rätt att begära tillgång till och en kopia av de personuppgifter
        som vi sparar om dig.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify", fontWeight: "bold" }}
      >
        Begära rättelse
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Du har rätt att begära rättelse av en personuppgift som du anser är
        felaktig eller ofullständig.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify", fontWeight: "bold" }}
      >
        Återkalla samtycke
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        I den utsträckning som vi behandlar dina personuppgifter med stöd av
        ditt samtycke har du rätt att, när som helst, återkalla ditt samtycke
        till behandlingen.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify", fontWeight: "bold" }}
      >
        Begära radering
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Under vissa omständigheter har du rätt att få dina personuppgifter
        raderade. Detta gäller dock inte om vi exempelvis är skyldiga enligt lag
        att bevara uppgifterna.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify", fontWeight: "bold" }}
      >
       Avregistrera dig från marknadsföring
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Du har rätt att motsätta dig vår behandling av dina personuppgifter för
        marknadsföringsända-mål. Du kan avregistrera dig från utskick genom att
        klicka på en avregisteringslänk i utskicket.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify", fontWeight: "bold" }}
      >
        Begära begränsning av behandling
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Du har även rätt att under vissa omständigheter begära att behandlingen
        av dina personuppgifter begränsas.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingTop: "4pt",
          paddingLeft: "41pt",
          textIndent: "0pt",
          textAlign: "justify",
          fontWeight: "bold"
        }}
      >
          Motsätta dig behandling som stödjer sig på vårt berättigade intresse
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Viss användning av dina personuppgifter stödjer sig på vårt eller annans
        berättigade intresse. Du har rätt att motsätta dig behandlingar som
        stödjer sig på ett berättigat intresse av skäl som rör din specifika
        situation. I en sådan situation kommer vi att sluta behandla dina
        personuppgifter när användningen stödjer sig på ett berättigat intresse,
        om vi inte kan visa att vi har avgörande berättigade skäl för
        behandlingen som överväger ditt integritetsintresse eller att
        användningen av dina personuppgifter är nödvändig för att hantera och
        bemöta rättsliga krav.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify", fontWeight: "bold" }}
      >
        Flytta din data (dataportabilitet)
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Du har rätt att under vissa omständigheter få en kopia på de
        personuppgifter som rör dig i ett strukturerat format (dataportabilitet)
        som du kan överföra till en annan mottagare.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={7}>
      <h2
        style={{ paddingLeft: "41pt", textIndent: "-36pt", textAlign: "left" }}
      >
        UPPDATERINGAR AV INFORMATIONEN
      </h2>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Vi kan ibland uppdatera denna integritetspolicy. Till exempel kan vi
        samla in ytterligare information eller använda informationen för andra
        ändamål än de som anges i texten. I sådant fall kommer vi att meddela
        dig i förväg på lämpligt sätt, t.ex. genom att visa ett meddelande i
        plattformen eller genom e-post. Den senaste versionen av
        integritetspolicyn finns allt publice-rad på denna sida.
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={8}>
      <h2
        style={{ paddingLeft: "41pt", textIndent: "-36pt", textAlign: "left" }}
      >
        OM DU HAR NÅGRA FRÅGOR
      </h2>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        <a href="mailto:mailbox@sbf.se" className="a">
          Om du har några frågor angående denna integritetspolicy eller vill
          utöva dina rättigheter, vänligen kontakta kansliet på{" "}
        </a>
        <a href="mailto:mailbox@sbf.se">
          mailbox@sbf.se.
        </a>
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Om du inte är nöjd med vårt svar har du rätt att lämna in klagomål till
        din dataskyddsmyndig-het, vilket i Sverige är Datainspektionen (se
        www.datainspektionen.se)
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "justify" }}
      >
        Personuppgiftsansvarig för hanteringen av dina personuppgifter enligt
        denna informationstext är:
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p
        style={{
          paddingLeft: "41pt",
          textIndent: "0pt",
          lineHeight: "13pt",
          textAlign: "left"
        }}
      >
        Svenska Bilsportförbundet, 802000-3425
      </p>
      <p
        style={{
          paddingLeft: "41pt",
          textIndent: "0pt",
          lineHeight: "13pt",
          textAlign: "left"
        }}
      >
        Box 705
      </p>
      <p
        style={{
          paddingLeft: "41pt",
          textIndent: "0pt",
          lineHeight: "13pt",
          textAlign: "left"
        }}
      >
        191 27 Sollentuna
      </p>
      <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left" }}>
        <a href="mailto:mailbox@sbf.se" className="a">
          E-post:{" "}
        </a>
        <a href="mailto:mailbox@sbf.se">
          mailbox@sbf.se
        </a>
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
    </li>
    <li data-list-text={9}>
      <h2
        style={{ paddingLeft: "41pt", textIndent: "-36pt", textAlign: "left" }}
      >
        KATEGORIER AV PERSONUPPGIFTER
      </h2>
    </li>
  </ol>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "41pt", textIndent: "0pt", textAlign: "left" }}>
    I tabellen nedan finns ytterligare information om vilka kategorier av
    uppgifter som vi behandlar och sparar om dig.
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "21pt" }}>
        <td
          style={{
            width: "147pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
          bgcolor="#F2F2F2"
        >
          <p
            className="s3"
            style={{
              paddingTop: "4pt",
              paddingRight: "53pt",
              textIndent: "0pt",
              textAlign: "right"
            }}
          >
            Kategori
          </p>
        </td>
        <td
          style={{
            width: "281pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
          bgcolor="#F2F2F2"
        >
          <p
            className="s3"
            style={{
              paddingTop: "4pt",
              paddingLeft: "93pt",
              paddingRight: "93pt",
              textIndent: "0pt",
              textAlign: "center"
            }}
          >
            Exempel på uppgifter
          </p>
        </td>
      </tr>
      <tr style={{ height: "69pt" }}>
        <td
          style={{
            width: "147pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s5"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Användargenererade uppgifter
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Uppgifter som du själv lämnat genom ditt beteende och din användning
          </p>
        </td>
        <td
          style={{
            width: "281pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Klickhistorik
          </p>
        </td>
      </tr>
      <tr style={{ height: "23pt" }}>
        <td
          style={{
            width: "147pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s5"
            style={{
              paddingRight: "51pt",
              textIndent: "0pt",
              textAlign: "right"
            }}
          >
            Bild- och ljudmaterial
          </p>
        </td>
        <td
          style={{
            width: "281pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Fotografi, film, ljudinspelning
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <table
    style={{ borderCollapse: "collapse", marginLeft: "36.53pt" }}
    cellSpacing={0}
  >
    <tbody>
      <tr style={{ height: "46pt" }}>
        <td
          style={{
            width: "147pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Uppgifter såsom din bild och din röst som har fotograferats eller
            spelats in.
          </p>
        </td>
        <td
          style={{
            width: "281pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
        </td>
      </tr>
      <tr style={{ height: "58pt" }}>
        <td
          style={{
            width: "147pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s5"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Fordonsuppgifter
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s4"
            style={{
              paddingLeft: "5pt",
              paddingRight: "5pt",
              textIndent: "0pt",
              textAlign: "left"
            }}
          >
            Uppgift om ditt registrerade fordon
          </p>
        </td>
        <td
          style={{
            width: "281pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Fabrikat, modell, fordonsår, modellår, status
          </p>
        </td>
      </tr>
      <tr style={{ height: "46pt" }}>
        <td
          style={{
            width: "147pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s5"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Hälsouppgifter
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Uppgifter om din hälsa
          </p>
        </td>
        <td
          style={{
            width: "281pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Hälsostatus, längd, vikt, eventuell medicinering
          </p>
        </td>
      </tr>
      <tr style={{ height: "47pt" }}>
        <td
          style={{
            width: "147pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s5"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Identitetsuppgifter
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Uppgifter som identifierar dig.
          </p>
        </td>
        <td
          style={{
            width: "281pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Namn, personnummer
          </p>
        </td>
      </tr>
      <tr style={{ height: "46pt" }}>
        <td
          style={{
            width: "147pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s5"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Klubbuppgifter
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Uppgifter som rör din klubb
          </p>
        </td>
        <td
          style={{
            width: "281pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Klubbtillhörighet
          </p>
        </td>
      </tr>
      <tr style={{ height: "69pt" }}>
        <td
          style={{
            width: "147pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s5"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Kommunikation
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s4"
            style={{
              paddingLeft: "5pt",
              paddingRight: "12pt",
              textIndent: "0pt",
              textAlign: "justify"
            }}
          >
            Uppgifter som du lämnar när du kommunicerar med oss på olika sätt
          </p>
        </td>
        <td
          style={{
            width: "281pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Innehållet i din kommunikation, t.ex. i e-postmeddelanden
          </p>
        </td>
      </tr>
      <tr style={{ height: "58pt" }}>
        <td
          style={{
            width: "147pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s5"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Kontaktuppgifter
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Uppgifter som möjliggör kontakt med dig
          </p>
        </td>
        <td
          style={{
            width: "281pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Mejladress, adress, telefonnummer
          </p>
        </td>
      </tr>
      <tr style={{ height: "58pt" }}>
        <td
          style={{
            width: "147pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s5"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Organisatorisk information
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Uppgifter som rör den organisation som du tillhör
          </p>
        </td>
        <td
          style={{
            width: "281pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Titel, organisationens namn
          </p>
        </td>
      </tr>
      <tr style={{ height: "46pt" }}>
        <td
          style={{
            width: "147pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s5"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Tekniska uppgifter
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Uppgifter av teknisk natur
          </p>
        </td>
        <td
          style={{
            width: "281pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s7"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            IP-adress, typ av operativsystem, webbläsare och enhet
          </p>
        </td>
      </tr>
      <tr style={{ height: "58pt" }}>
        <td
          style={{
            width: "147pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s5"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Tävlandestatus
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Uppgift om din status som täv-lande
          </p>
        </td>
        <td
          style={{
            width: "281pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Aktiv, avstängd
          </p>
        </td>
      </tr>
      <tr style={{ height: "46pt" }}>
        <td
          style={{
            width: "147pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s5"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Tävlingsuppgifter
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Uppgifter om tävlingar
          </p>
        </td>
        <td
          style={{
            width: "281pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Tävlingsresultat, uppgift om deltagande i tävling
          </p>
        </td>
      </tr>
      <tr style={{ height: "58pt" }}>
        <td
          style={{
            width: "147pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s5"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Utbildningsuppgifter
          </p>
          <p style={{ textIndent: "0pt", textAlign: "left" }}>
            <br />
          </p>
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Uppgifter som rör utbildning som du har genomfört
          </p>
        </td>
        <td
          style={{
            width: "281pt",
            borderTopStyle: "solid",
            borderTopWidth: "1pt",
            borderTopColor: "#DADADA",
            borderLeftStyle: "solid",
            borderLeftWidth: "1pt",
            borderLeftColor: "#DADADA",
            borderBottomStyle: "solid",
            borderBottomWidth: "1pt",
            borderBottomColor: "#DADADA",
            borderRightStyle: "solid",
            borderRightWidth: "1pt",
            borderRightColor: "#DADADA"
          }}
        >
          <p
            className="s4"
            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
          >
            Typ av utbildning, tidpunkt för utbildning, resultat
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</>
  );
}

export default IntegrityPolicy;
